import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface HeadingBaseProps {
  $noMargin?: boolean;
  $contentWidth?: boolean;
  $weight?: string;
  $lineHeight?: string;
  as?: string;
}

const HeadingBase = styled.div<HeadingBaseProps>`
  display: block;
  margin-top: 0;
  margin-bottom: ${size(2)};
  line-height: ${({ $lineHeight }) => $lineHeight || '1.2'};
  font-stretch: ${(props) => props.theme.font.stretch.condensed};

  ${({ $noMargin }) =>
    $noMargin &&
    css`
      margin-bottom: 0;
    `}

  ${({ $contentWidth }) =>
    $contentWidth &&
    css`
      max-width: ${(props) => props.theme.size.contentMaxWidth};
    `}

    ${({ $weight }) =>
      $weight === 'bold'
        ? css`
            font-weight: ${(props) => props.theme.font.weight.bold};
          `
        : css`
            font-weight: ${(props) => props.theme.font.weight.regular};
          `}
`;

export const H1 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h1',
}))`
  font-size: ${(props) => props.theme.font.size.xxxlarge};
  letter-spacing: -0.8px;
  font-weight: ${(props) => props.theme.font.weight.extraLight};
  ${(props) => props.theme.breakpoint.LtSm} {
    font-size: 2rem;
  }

  line-height: ${(props) => props.theme.font.lineHeight.none};
  vertical-align: middle;
`;

export const H2 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h2',
}))`
  font-size: ${(props) => props.theme.font.size.xxlarge};
  letter-spacing: -0.5px;
`;

export const H3 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h3',
}))`
  font-size: ${(props) => props.theme.font.size.xlarge};
  letter-spacing: -0.5px;
`;

export const H4 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h4',
}))`
  font-size: ${(props) => props.theme.font.size.xlarge};
  font-weight: ${(props) => props.theme.font.weight.extraLight};
  line-height: ${(props) => props.theme.font.lineHeight.none};
  vertical-align: middle;
`;

export const StyledH1 = styled(H1)`
  font-family: 'Permanent Marker';
`;
